import { render, staticRenderFns } from "./ProductInformationDisclosurePopupIframe.vue?vue&type=template&id=a102b394&"
import script from "./ProductInformationDisclosurePopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductInformationDisclosurePopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports